<template>
  <div class="card-form">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditDialog="openEditDialog"
    >
      <template #header>
        <div class="d-flex align-items-center">
          <b-form-radio-group
            style="margin-right: 10px;"
            v-model="riskCheckStatus"
            :options="riskCheckStatusOptions"
            button-variant="outline-primary"
            name="radio-btn-outline"
            size="sm"
            buttons
            @change="reload"
          />
          <div class="flex-grow-1">
            <PageHeader
              ref="header"
              @query="getData"
              @reset="resetPage"
              @openEditDialog="openEditDialog"
            />
          </div>
        </div>
      </template>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <EditForm
      :visible.sync="editOptions.visible"
      :type="editOptions.type"
      :riskCheckCode="editOptions.riskCheckCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageMain from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import EditForm from '../edit-form'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageHeader, PageMain, EditForm },
  data() {
    return {
      usePage: true,
      riskCheckStatus: '',
      editOptions: { visible: false, code: '' },
    }
  },
  computed: {
    riskCheckStatusOptions() {
      return [
        {
          text: this.$l('form_label_riskCheckStatus_all') || '全部',
          value: '',
        },
        {
          text: this.$l('form_label_riskCheckStatus_N') || '待核查',
          value: 'N',
        },
        {
          text: this.$l('form_label_riskCheckStatus_Y') || '已核查',
          value: 'Y',
        },
      ]
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .customerRiskCheckListApi({
          ...form,
          ...this.page,
          riskCheckStatus: this.riskCheckStatus,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditDialog({ type, data: { riskCheckCode } = {} }) {
      this.editOptions = { visible: true, type, riskCheckCode }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-button--wrapper > div {
    width: 100%;
    max-width: 750px;
    padding-right: 20px;
    div[role='radiogroup'].btn-group {
      .btn {
        width: 80px;
        min-width: 80px;
        line-height: 1.4;
      }
    }
  }
}
</style>
